<template>
  <!--企业营收及研发投入 -->
  <div class="rightbox backwhite width86 border-rd3" style="min-height: 800px">
    <div class="toolbtn flex margin-right10">
      <el-tooltip class="item" effect="dark" content="刷新" placement="top">
        <div @click="refresh()" class="cursorpointer margin-top10">
          <img
            src="@/assets/barsvg/icon／12sx(1).png"
            style="position: relative; top: 2px"
            alt=""
          />
          <span class="f12 pad-left5" style="color: #969eac">刷新</span>
        </div>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="返回" placement="top">
        <callback></callback>
      </el-tooltip>
    </div>
    <el-skeleton class="width100" :loading="true" animated :throttle="200">
      <template slot="template">
        <p
          class="
            flex-betweennowrap
            width98
            margin-auto margin-top20 margin-bot10
          "
        >
          <span class="dimensional">企业营收及研发投入</span>
          <span class="attention f14" @click="tocollectionadd()">新 增</span>
        </p>

        <el-table
          :data="page"
          stripe
          class="eltable width98 margin-auto f14"
          v-if="total != 0"
        >
          <el-table-column label="统计年度" align="left" width="220">
            <template slot-scope="scope">
              <span
                class="cursorpointer bluecolor"
                @click="previewreport(scope.row)"
                >{{ scope.row.year }} 年度(单位:万元)</span
              ></template
            >
          </el-table-column>
          <el-table-column label="月份" align="center" prop="month" />
          <el-table-column label="营业收入" align="center" prop="income" />

          <el-table-column label="利润" align="center" prop="profit" />
          <el-table-column
            label="研发投入"
            align="center"
            prop="rd_investment"
          />
          <el-table-column
            label="资产总额"
            align="center"
            prop="asset_amount"
          />
          <el-table-column label="净资产" align="center" prop="net_assets" />
          <el-table-column label="负债" align="center" prop="debt" />
          <el-table-column
            label="操作"
            align="center"
            class-name="small-padding fixed-width"
          >
            <template slot-scope="scope">
              <div class="cursorpointer flex">
                <span class="bluecolor" @click="previewreport(scope.row)"
                  >详情</span
                >
                <span
                  class="pad-left20 bluecolor"
                  @click="collectionmodify(scope.row)"
                  >修改</span
                >
                <span
                  class="pad-left20 bluecolor"
                  @click="designDetail(scope.row)"
                  >删除</span
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div
          class="
            flex-betweennowrap
            width98
            margin-auto
            pad-top20 pad-bot20 pad-left10 pad-right10
          "
          v-if="total != 0"
        >
          <span class="f14" style="color: #409eff"></span>
          <el-pagination
            :hide-on-single-page="true"
            @size-change="handleSizeChange"
            @current-change="currentchange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 30, 40, 50]"
            :page-size="per_page"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            background
          >
          </el-pagination>
        </div>
        <div
          class="width100 margin-auto backgroudFFF margin-top15"
          v-if="total == 0"
        >
          <el-empty
            :image="require('@/assets/barsvg/zwsj@3x.png')"
            :image-size="200"
            description="抱歉，没有搜到您想要的内容"
            class="heightempty"
            ><p style="position: relative; bottom: 60px" class="f14">
              暂无数据
            </p></el-empty
          >
        </div>
      </template>
    </el-skeleton>

    <!-- 详情 -->

    <el-dialog
      title=""
      :visible.sync="dialogVisibledetail"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="30%"
      class="errorbox"
    >
      <div class="f16 width98 textalign-left dimensional">
        企业营收及研发投入详情
      </div>
      <div class="margon-auto margin-top30">
        <div class="table">
          <div class="leftboxs">统计年度 :</div>
          <div class="rightboxs">{{ yeardeta }} 年度</div>
        </div>
        <div class="table">
          <div class="leftboxs">月份 :</div>
          <div class="rightboxs">{{ month }} 月份</div>
        </div>
        <div class="table">
          <div class="leftboxs">营业收入 :</div>
          <div class="rightboxs">{{ income }} 万元</div>
        </div>
        <div class="table">
          <div class="leftboxs">利润 :</div>
          <div class="rightboxs">{{ profit }} 万元</div>
        </div>
        <div class="table">
          <div class="leftboxs">研发投入 :</div>
          <div class="rightboxs">{{ rd_investment }} 万元</div>
        </div>
        <div class="table">
          <div class="leftboxs">资产总额 :</div>
          <div class="rightboxs">{{ asset_amount }} 万元</div>
        </div>
        <div class="table">
          <div class="leftboxs">净资产 :</div>
          <div class="rightboxs">{{ net_assets }} 万元</div>
        </div>
        <div class="table">
          <div class="leftboxs">负债 :</div>
          <div class="rightboxs">{{ debt }} 万元</div>
        </div>
      </div>
      <div class="textalign-right margin-top20">
        <el-button @click="dialogVisibledetail = false">关闭</el-button>
      </div>
    </el-dialog>
    <!-- 新增 -->

    <el-dialog
      title=""
      :visible.sync="dialogVisibleadd"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="30%"
      class="errorboxs"
    >
      <div class="f16 width98 textalign-left dimensional">
        企业营收及研发投入新增
      </div>
      <div class="pad-top30">
        <div class="bg-box">
          <div>统计年度</div>
          <div class="box-right">
            <el-date-picker
              class="inputDeep"
              v-model="year"
              type="year"
              placeholder="请选择年度"
              :editable="false"
              value-format="yyyy"
            ></el-date-picker>
          </div>
        </div>
        <div class="bg-box">
          <div>月份</div>
          <div class="box-right">
            <el-date-picker
              class="inputDeep"
              v-model="month"
              type="month"
              placeholder="请选择月份"
              :editable="false"
              value-format="MM"
            ></el-date-picker>
          </div>
        </div>
        <div class="bg-box">
          <div>营业收入(万元)</div>
          <div class="box-right">
            <el-input
              type="number"
              class="inputDeep"
              placeholder="请输入营业收入"
              v-model="income"
            />
          </div>
        </div>

        <div class="bg-box">
          <div>利润(万元)</div>
          <div class="box-right">
            <el-input
              type="number"
              class="inputDeep"
              placeholder="请输入利润"
              v-model="profit"
            />
          </div>
        </div>

        <div class="bg-box">
          <div>研发投入(万元)</div>
          <div class="box-right">
            <el-input
              type="number"
              class="inputDeep"
              placeholder="请输入研发投入"
              v-model="rd_investment"
            />
          </div>
        </div>

        <div class="bg-box">
          <div>资产总额(万元)</div>
          <div class="box-right">
            <el-input
              type="number"
              class="inputDeep"
              placeholder="请输入资产总额"
              v-model="asset_amount"
            />
          </div>
        </div>

        <div class="bg-box">
          <div>净资产(万元)</div>
          <div class="box-right">
            <el-input
              type="number"
              class="inputDeep"
              placeholder="请输入净资产"
              v-model="net_assets"
            />
          </div>
        </div>
        <div class="bg-box">
          <div>负债(万元)</div>
          <div class="box-right">
            <el-input
              type="number"
              class="inputDeep"
              placeholder="请输入负债金额"
              v-model="debt"
            />
          </div>
        </div>
      </div>
      <div class="textalign-right margin-top20">
        <el-button @click="dialogVisibleadd = false">取 消</el-button>
        <el-button type="primary" @click="Savechanges()"> 确 定 </el-button>
      </div>
    </el-dialog>
    <!-- 修改 -->
    <el-dialog
      title=""
      :visible.sync="dialogVisiblemodify"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="30%"
      class="errorboxs"
    >
      <div class="f16 width98 textalign-left dimensional">
        企业营收及研发投入修改
      </div>
      <div class="pad-top30">
        <div class="bg-box">
          <div>统计年度</div>
          <div class="box-right">
            <el-date-picker
              class="inputDeep"
              v-model="year"
              type="year"
              placeholder="请选择年度"
              :editable="false"
              value-format="yyyy"
            ></el-date-picker>
          </div>
        </div>
        <div class="bg-box">
          <div>月份</div>
          <div class="box-right">
            <el-date-picker
              class="inputDeep"
              v-model="month"
              type="month"
              placeholder="请选择月份"
              :editable="false"
              value-format="MM"
            ></el-date-picker>
          </div>
        </div>

        <div class="bg-box">
          <div>营业收入(万元)</div>
          <div class="box-right">
            <el-input
              type="number"
              class="inputDeep"
              placeholder="请输入营业收入"
              v-model="income"
            />
          </div>
        </div>

        <div class="bg-box">
          <div>利润(万元)</div>
          <div class="box-right">
            <el-input
              type="number"
              class="inputDeep"
              placeholder="请输入利润"
              v-model="profit"
            />
          </div>
        </div>

        <div class="bg-box">
          <div>研发投入(万元)</div>
          <div class="box-right">
            <el-input
              type="number"
              class="inputDeep"
              placeholder="请输入研发投入"
              v-model="rd_investment"
            />
          </div>
        </div>

        <div class="bg-box">
          <div>资产总额(万元)</div>
          <div class="box-right">
            <el-input
              type="number"
              class="inputDeep"
              placeholder="请输入资产总额"
              v-model="asset_amount"
            />
          </div>
        </div>

        <div class="bg-box">
          <div>净资产(万元)</div>
          <div class="box-right">
            <el-input
              type="number"
              class="inputDeep"
              placeholder="请输入净资产"
              v-model="net_assets"
            />
          </div>
        </div>
        <div class="bg-box">
          <div>负债(万元)</div>
          <div class="box-right">
            <el-input
              type="number"
              class="inputDeep"
              placeholder="请输入负债金额"
              v-model="debt"
            />
          </div>
        </div>
      </div>
      <div class="textalign-right margin-top20">
        <el-button @click="dialogVisiblemodify = false">取 消</el-button>
        <el-button class="" type="primary" @click="Savechangemodify()">
          确 定
        </el-button>
      </div>
    </el-dialog>
    <!-- 错误弹窗 -->
    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  entbenefitsindex,
  entbenefitsdelete,
  entbenefitsdetail,
  entbenefitssave,
  entbenefitsupdate,
} from "@/api/business/business.api";
import callback from "@/components/callback.vue";
export default {
  data() {
    return {
      errormessage: "",
      dialogVisiblenull: false,
      page: [],
      total: 0,
      per_page: 0,
      currentPage: 1,
      dialogVisibledetail: false,
      year: "",
      month: "",
      yeardeta: "",
      income: "",
      debt: "",
      profit: "",
      rd_investment: "",
      asset_amount: "",
      net_assets: "",
      dialogVisibleadd: false,
      dialogVisiblemodify: false,
      modifyid: "",
    };
  },
  components: {
    callback,
  },
  methods: {
    // 详情
    previewreport(row) {
      this.dialogVisibledetail = true;
      entbenefitsdetail({
        id: row.id,
      }).then((res) => {
        if (res.data.code == 200) {
          this.yeardeta = res.data.data.year.toString();
          this.income = res.data.data.income;
          this.debt = res.data.data.debt;
          this.profit = res.data.data.profit;
          this.rd_investment = res.data.data.rd_investment;
          this.asset_amount = res.data.data.asset_amount;
          this.net_assets = res.data.data.net_assets;
          this.month = res.data.data.month;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 新增
    tocollectionadd() {
      this.dialogVisibleadd = true;
      this.yeardeta = "";
      this.income = "";
      this.debt = "";
      this.profit = "";
      this.rd_investment = "";
      this.asset_amount = "";
      this.net_assets = "";
      this.month = "";
    },
    Savechanges() {
      entbenefitssave({
        year: this.year,
        income: this.income,
        debt: this.debt,
        profit: this.profit,
        rd_investment: this.rd_investment,
        asset_amount: this.asset_amount,
        net_assets: this.net_assets,
        month: this.month,
      }).then((res) => {
        if (res.data.code == 200) {
          this.refresh();
          this.dialogVisibleadd = false;
          this.dialogVisiblemodify = false;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 修改
    collectionmodify(row) {
      this.dialogVisiblemodify = true;
      this.modifyid = row.id;
      entbenefitsdetail({
        id: row.id,
      }).then((res) => {
        if (res.data.code == 200) {
          this.yeardeta = res.data.data.year.toString();
          this.income = res.data.data.income;
          this.debt = res.data.data.debt;
          this.profit = res.data.data.profit;
          this.rd_investment = res.data.data.rd_investment;
          this.asset_amount = res.data.data.asset_amount;
          this.net_assets = res.data.data.net_assets;
          this.month = res.data.data.month;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    Savechangemodify() {
      if (this.record == "未备案") {
        this.record = 0;
      } else if (this.record == "已备案") {
        this.record = 1;
      }

      entbenefitsupdate({
        id: this.modifyid,
        year: this.year,
        income: this.income,
        debt: this.debt,
        profit: this.profit,
        rd_investment: this.rd_investment,
        asset_amount: this.asset_amount,
        net_assets: this.net_assets,
        month: this.month,
      }).then((res) => {
        if (res.data.code == 200) {
          this.refresh();
          this.dialogVisibleadd = false;
          this.dialogVisiblemodify = false;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 删除项目
    designDetail(row) {
      this.$confirm("此操作将删除此项目, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          entbenefitsdelete({ id: row.id }).then((res) => {
            if (res.data.code == 200) {
              this.refresh();
            } else {
              this.dialogVisiblenull = true;
              this.errormessage = res.data.msg;
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    // 第一个分页
    currentchange(val) {
      this.thisNum = val;
      entbenefitsindex({ page: val }).then((res) => {
        if (res.data.code == 200) {
          this.page = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    handleSizeChange(val) {
      entbenefitsindex({ page: 1, limit: val }).then((res) => {
        if (res.data.code == 200) {
          this.page = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    refresh() {
      this.$loading.show(); // 显示loading
      entbenefitsindex({ page: this.thisNum }).then((res) => {
        if (res.data.code == 200) {
          this.page = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
          this.$loading.hide(); // 隐藏loading
        } else {
          this.$loading.hide(); // 隐藏loading
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
  },
  created() {
    entbenefitsindex({ page: this.thisNum }).then((res) => {
      if (res.data.code == 200) {
        this.page = res.data.data.data;
        this.total = res.data.data.total;
        this.per_page = res.data.data.per_page;
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
  },
};
</script>
      <style scoped>
.table {
  width: 98%;
  display: flex;
  margin: auto;
  text-align: left;
  font-size: 14px;
  color: #4f4f4f;
  line-height: 40px;
}
.leftboxs {
  min-width: 70px;
  color: #353a44;
  padding: 0 0 0 5px;
}
.rightboxs {
  margin-left: 10px;
  color: #6a7589;
  padding: 0 0 0 5px;
}

/* 表单盒子 */
.bg-box {
  width: 100%;
  margin: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  padding: 10px 0 10px 0;
  color: #4f4f4f;
  font-size: 14px;
}
.inputDeep {
  width: 100%;
}
.box-right {
  padding-top: 5px;
  width: 100%;
  position: relative;
}
.el-select {
  width: 100%;
}
.el-input-number--small {
  width: 100%;
}
.textarea {
  width: 170%;
  height: 80px;
  border: 1px solid #efefef;
  outline: none;
  padding: 10px 0 0 5px;
}

.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorboxs >>> .el-dialog__header {
  text-align: left;
}
.errorboxs >>> .el-dialog__title {
  text-align: left;
  font-size: 16px;
  color: #606266;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 10%;
}
.eltable >>> .el-table__header-wrapper th {
  background-color: #f1f3f9;
  height: 40px;
  font-size: 14px;
  border-radius: 3px;
}
</style>